export const DEFAULT_PRIVACY_URL = 'https://dfd.nl/klantenservice/privacy-statement/';
